import axios from "axios"
import { setToken, refreshToken } from '../interceptors/jwt-interceptor'
import '../interceptors/loader-interceptor'
import '../interceptors/internal-server-interceptor'
import { apiErrorText } from '../shared/constant'
import { errorToastr } from "./error-handler"
var CryptoJS = require("crypto-js");


const apiUrl = process.env.GATASBY_API_URL;
//data encrypt 
export const aesEncryptData = data => {
    if (typeof window === "undefined") {
      return
    }
    else
    return  CryptoJS.AES.encrypt(JSON.stringify(data), `${process.env.DECRYPT_KEY}`).toString();
  }


export const generateAccessTokenFromRefresh = (data) => {
    if (typeof window === "undefined") {
        return
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/generate-accessToken-from-refeshToken`, data)
            .then(res => {
                if (res.data?.accessToken) {
                    setToken(res.data)
                    resolve(res)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const eKyc = (data) => {
    if (typeof window === "undefined") {
        return;
    }
    let encryptData = aesEncryptData(data)
    console.log("data",encryptData);
    let encyptedPayload = {
      encryptData: encryptData
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/consumerekyc-send-otp`, encyptedPayload)
            .then((res) => {
                // if(apiErrorText.includes(res?.status)){
                //     errorToastr(res.MESSAGE)
                // }
                let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                //  console.log("dcrypteddata",decryptedData);
                res.data = decryptedData
                if (res && res.data) {
                    resolve(res?.data)
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            eKyc(data)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    if ([500, 400].includes(error?.response?.status)) {
                                        errorToastr(error.response.data.message)
                                    }
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            if ([500, 400].includes(error?.response?.status)) {
                                errorToastr(error.response.data.message)
                            }
                            reject(error)
                        })
                } else {
                    if ([500, 400].includes(error?.response?.status)) {
                        errorToastr(error.response.data.message)
                    }
                    reject(error)
                }
            })
    });
}

export const eKycVerify = (data) => {
    if (typeof window === "undefined") {
        return;
    }
    let encryptData = aesEncryptData(data)
    console.log("data",encryptData);
    let encyptedPayload = {
      encryptData: encryptData
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/consumerekyc-verify-kyc`, encyptedPayload)
            .then((res) => {
                // if(apiErrorText.includes(res?.status)){
                //     errorToastr(res.MESSAGE)
                // }
                let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                //  console.log("dcrypteddata",decryptedData);
                res.data = decryptedData
                if (res && res.data) {
                    resolve(res?.data)
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            eKycVerify(data)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    if ([500, 400].includes(error?.response?.status)) {
                                        errorToastr(error.response.data.message)
                                    }
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            if ([500, 400].includes(error?.response?.status)) {
                                errorToastr(error.response.data.message)
                            }
                            reject(error)
                        })
                } else {
                    if ([500, 400].includes(error?.response?.status)) {
                        errorToastr(error.response.data.message)
                    }
                    reject(error)
                }
            })
    });
}

// ckyc search

export const cKycSearch = (data) => {
    if (typeof window === "undefined") {
        return;
    }
    let encryptData = aesEncryptData(data)
    console.log("data",encryptData);
    let encyptedPayload = {
      encryptData: encryptData
    }
    return new Promise((resolve, reject) => {
        axios.post(`${apiUrl}/ckyc-search`, encyptedPayload)
            .then((res) => {
                console.log(res);
                let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                //  console.log("dcrypteddata",decryptedData);
                res.data = decryptedData
                if (apiErrorText.includes(res?.status)) {
                    console.log("3");

                    errorToastr(res.MESSAGE)
                }
                if (res && res.data) {
                    console.log('res.data', res.data);
                    resolve(res?.data)
                } else {
                    reject();
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            cKycSearch(data)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    if ([500, 400].includes(error?.response?.status)) {
                                        errorToastr(error.response.data.message)
                                    }
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            if ([500, 400].includes(error?.response?.status)) {
                                errorToastr(error.response.data.message)
                            }
                            reject(error)
                        })
                } else {
                    if ([500, 400].includes(error?.response?.status)) {
                        errorToastr(error.response.data.message)
                    }
                    reject(error)
                }
            })
    });
}